import { useParams } from "react-router";
import ProfileActions from "./ProfileActions";
import { useEffect, useRef, useState } from "react";
import { userServices } from "../APIServices/userServices";
import { Button, Collapse, ListGroup } from "react-bootstrap";

let role = JSON.parse(localStorage.getItem("role"));

const Navbar = ({ setOpenModule, setShowSidebar, handleAddNewTab }) => {
  const { studyId } = useParams();
  const [image, setImage] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [managementRole, setManagementRole] = useState("");

  const AppsRef = useRef(null);
  const [AppsActive, setAppsActive] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setAppsActive(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const getGMTOffset = () => {
    const offsetMinutes = new Date().getTimezoneOffset();
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const absMinutes = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
    const minutes = String(absMinutes % 60).padStart(2, '0');
    return `GMT${sign}${hours}:${minutes}`;
  }

  useEffect(() => {
    profileData();
  }, []);

  const profileData = async () => {
    const item1 = JSON.parse(localStorage.getItem("firstName"));
    const item2 = JSON.parse(localStorage.getItem("lastName"));
    if (item1) {
      setFirstName(item1);
    }
    if (item2) {
      setLastName(item2);
    }
  };

  const roleType = JSON.parse(localStorage.getItem("role"));

  const logout = async () => {
    await userServices.logout();
  };

  useEffect(() => {
    const currentDetails = async (e) => {
      let userData = await userServices.getCurrentUserDetails(e);
      setManagementRole(userData?.[1]?.management_name?.name);
      setImage(userData?.[0]?.user_id?.image);
    };
    currentDetails();
  }, [studyId]);

  return (
    <>
      <div style={{ background: "var(--blue)" }}>
        <div className="hstack justify-content-between border-bottom border-secondary px-2 py-1">
          <h4 className="text-white m-0">Galax®</h4>
          <div className="hstack justify-content-between gap-2">
            <span className="text-white"><i className="fa-solid fa-earth-asia me-1 text-info"></i>Timezone: {getGMTOffset() || "NA"}</span>
            <span className="text-white"><i className="fa-solid fa-building-user me-1 text-info"></i>Logged in as :{" "}
              {roleType === "client"
                ? "Admin"
                : roleType === "user"
                  ? managementRole
                  :""}
            </span>
            <div className="hstack gap-1">
              <ProfileActions
                handleAddNewTab={handleAddNewTab}
                ProfileImage={image}
                firstName={firstName}
                lastName={lastName}
              />
              <Button
                onClick={logout}
                variant="outline-danger"
                className="p-1 px-2 border-0 br3"
                style={{ fontSize: 13 }}
                title="Sign out from panel"
              >
                <i className="fa-solid fa-right-from-bracket me-1"></i>Signout
              </Button>
            </div>
          </div>
        </div>
        <div className="hstack justify-content-between filebar" style={{ height: 35, padding: 5 }}>
          <div ref={AppsRef}>
            {(role === "user" || role === "client") &&
              <Button className="position-relative border-0 py-1 px-2 text-start" variant="outline-light" onClick={() => setAppsActive(!AppsActive)}>
                <div className="hstack gap-1" style={{fontSize: 12}}>
                  <i className="fa-solid fa-grip me-1 text-info"></i>
                  <p className="m-0">Apps</p>
                  <i className={`fa-solid fa-angle-${AppsActive ? "up" : "down"}`}></i>
                </div>
                <Collapse in={AppsActive === true}>
                  <div className="position-absolute start-0" style={{ top: 31, zIndex: 999 }}>
                    <ListGroup style={{ fontSize: 12, width: "max-content" }}>
                      {role === "client" &&
                        <>
                          <ListGroup.Item action onClick={() => { setOpenModule("clients"); setShowSidebar(true) }} title="Clients Management">
                            <i className={`fa-solid fa-building-user me-2`}></i>Clients Management
                          </ListGroup.Item>
                          <ListGroup.Item action onClick={() => { setOpenModule("users"); setShowSidebar(true) }} title="Users Management">
                            <i className={`fa-solid fa-users me-2`}></i>Users Management
                          </ListGroup.Item>
                        </>
                      }
                      <ListGroup.Item action onClick={() => { setOpenModule("logs"); setShowSidebar(true) }} title="Logs Management">
                        <i className={`fa-solid fa-clock-rotate-left me-2`}></i>Logs Management
                      </ListGroup.Item>
                    </ListGroup>
                  </div>
                </Collapse>
              </Button>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
